import React from 'react';
const nodes = [{
  id: '01',
  label: 'More users',
  description: 'Organic growth from word of mouth'
}, {
  id: '02',
  label: 'Richer neighborhood understanding',
  description: 'Every query teaches Navi about a place'
}, {
  id: '03',
  label: 'Better recommendations',
  description: 'Precision improves with each interaction'
}, {
  id: '04',
  label: 'More engagement',
  description: 'Users come back because it works'
}, {
  id: '05',
  label: 'More behavioral signals',
  description: 'Actions > opinions. Training data'
}, {
  id: '06',
  label: 'Deeper vibe map',
  description: 'The human layer gets richer'
}];
export function FlywheelSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-208">
      <div className="flex flex-row w-full h-full min-h-0 relative overflow-hidden" data-id="element-209">
        {/* Left Panel — heading, vertically centered */}
        <div className="flex flex-col justify-center w-[40%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        padding: 'var(--slide-padding)',
        paddingLeft: 'clamp(2rem, 6vw, 6rem)'
      }} data-id="element-210">
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
          animationDelay: '0.1s'
        }} data-id="element-211">
            The compounding advantage.
          </p>

          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.15s'
        }} data-id="element-212">
            Every interaction deepens the map.
          </h1>
        </div>

        {/* Right Panel — vertical timeline */}
        <div className="flex-1 flex flex-col justify-center min-h-0 overflow-hidden relative" style={{
        padding: 'var(--slide-padding)',
        paddingRight: 'clamp(2rem, 6vw, 6rem)'
      }} data-id="element-213">
          {/* Timeline container */}
          <div className="flex flex-col relative" data-id="element-214">
            {/* Vertical line */}
            <div className="absolute top-0 bottom-0" style={{
            left: 'clamp(14px, 1.8vw, 22px)',
            width: '1px',
            background: 'linear-gradient(180deg, rgba(74,144,217,0.4) 0%, rgba(74,144,217,0.15) 100%)'
          }} data-id="element-215" />

            {nodes.map((node, i) => <div key={node.id} data-id="element-216">
                {/* Step row */}
                <div className="flex items-start animate-fade-slide relative" style={{
              animationDelay: `${0.2 + i * 0.08}s`,
              paddingLeft: 'clamp(36px, 4.5vw, 56px)',
              paddingTop: i === 0 ? '0' : 'clamp(0.4rem, 0.8vw, 0.6rem)',
              paddingBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)'
            }} data-id="element-217">
                  {/* Step number — positioned on the timeline */}
                  <span className="absolute font-mono font-semibold" style={{
                left: '0',
                top: i === 0 ? '0' : 'clamp(0.4rem, 0.8vw, 0.6rem)',
                color: '#4A90D9',
                fontSize: 'clamp(0.75rem, 1.2vw, 1rem)',
                width: 'clamp(28px, 3.5vw, 44px)',
                textAlign: 'right',
                paddingRight: 'clamp(8px, 1vw, 14px)'
              }} data-id="element-218">
                    {node.id}
                  </span>

                  {/* Content */}
                  <div data-id="element-219">
                    <p className="font-bold text-white leading-snug" style={{
                  fontSize: 'clamp(0.9rem, 1.5vw, 1.2rem)',
                  marginBottom: 'clamp(0.1rem, 0.2vw, 0.15rem)'
                }} data-id="element-220">
                      {node.label}
                    </p>
                    <p className="leading-snug" style={{
                  color: 'rgba(255,255,255,0.45)',
                  fontSize: 'var(--body-size)'
                }} data-id="element-221">
                      {node.description}
                    </p>
                  </div>
                </div>

                {/* Chevron separator between items */}
                {i < nodes.length - 1 && <div className="flex items-center animate-fade-slide" style={{
              paddingLeft: 'clamp(36px, 4.5vw, 56px)',
              animationDelay: `${0.24 + i * 0.08}s`
            }} data-id="element-222">
                    <div style={{
                width: '100%',
                height: '1px',
                backgroundColor: 'rgba(255,255,255,0.06)',
                position: 'relative'
              }} data-id="element-223">
                      <span className="absolute" style={{
                  left: '0',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#4A90D9',
                  fontSize: 'clamp(0.65rem, 1vw, 0.85rem)',
                  opacity: 0.5,
                  lineHeight: 1
                }} data-id="element-224">
                        ˅
                      </span>
                    </div>
                  </div>}
              </div>)}
          </div>

          {/* Cycle repeats badge */}
          <div className="flex items-center animate-fade-slide" style={{
          paddingLeft: 'clamp(36px, 4.5vw, 56px)',
          marginTop: 'clamp(0.75rem, 1.5vw, 1.25rem)',
          animationDelay: '0.7s'
        }} data-id="element-225">
            <div className="flex items-center rounded-full" style={{
            border: '1px solid rgba(74, 144, 217, 0.3)',
            backgroundColor: 'rgba(74, 144, 217, 0.08)',
            padding: 'clamp(0.3rem, 0.6vw, 0.5rem) clamp(0.75rem, 1.5vw, 1.25rem)',
            gap: 'clamp(0.3rem, 0.6vw, 0.5rem)'
          }} data-id="element-226">
              <span style={{
              color: '#4A90D9',
              fontSize: 'clamp(0.65rem, 1vw, 0.85rem)'
            }} data-id="element-227">
                ↻
              </span>
              <span className="uppercase tracking-[0.15em] font-semibold" style={{
              color: '#4A90D9',
              fontSize: 'clamp(0.55rem, 0.85vw, 0.7rem)'
            }} data-id="element-228">
                Cycle Repeats
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}